// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__jmXtJ","copyRight":"Footer_copyRight__Hwf14"};